generateArrayPrefix